import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isShown)?_c('div',{staticClass:"page-error"},[_c('h2',{staticClass:"mb-8"},[_vm._v(_vm._s(_vm.message))]),(_vm.reload)?_c(VBtn,{staticClass:"mt-3 ksa-btn",attrs:{"depressed":"","color":"primary"},on:{"click":_vm.reloadPage}},[_vm._v(" Reload Page ")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }